import { type CommentActionsContextInterface } from '@databases/comments/context/CommentContext';
import { type MenuItem } from '@databases/contextual-menu/ContextualMenu';
import { type DialogContextInterface } from '@databases/dialog';
import { type MessageFormatter } from '@databases/intl/intl-types';
import { type PanelManager } from '@databases/panel-types';
import { type SelectionsActions } from '@databases/selections-api-types';

export type SelectedValueCoordinate = { fieldId: string; entryId: string };

/**
 * This context is built on demand and passed to each menu action.
 */
export interface CellContextMenuContext {
  baseUrl: string;
  capabilities: {
    canAskRovo: boolean;
    canBulkEditValues: boolean;
    canClearContent: boolean;
    canCopyValue: boolean;
    canDeleteEntries: boolean;
    canDeleteFields: boolean;
    canInsertContent: boolean;
    canOpenComments: boolean;
  };
  comments: {
    setOpenThread: CommentActionsContextInterface['setOpenThread'];
  };
  contentId: string;
  currentViewId: string;
  databasePath: string;
  dialogs: {
    showDialog: DialogContextInterface['showDialog'];
  };
  entryId: string;
  fieldId: string;
  formatMessage: MessageFormatter;
  isHoverDeleteEntriesButton: boolean;
  isHoverDeleteFieldsButton: boolean;
  panelManager: PanelManager;
  panel?: boolean;
  selectionsActions: SelectionsActions;
  selectedEntriesCount: number;
  selectedEntryIds: string[];
  selectedFieldIds: string[];
  selectedFieldsCount: number;
  selectedValues: SelectedValueCoordinate[];
  selectedValuesCount: number;
}

/**
 * The list of allowed actions for the select value menu.
 */
export enum SELECT_VALUE_MENU_ACTIONS {
  ADD_ENTRY_BELOW = 'add_entry_below',
  ADD_FIELD_RIGHT = 'add_field_right',
  ASK_ROVO = 'ask_rovo',
  BULK_EDIT_VALUES = 'bulk_edit_values',
  CLEAR_VALUES = 'clear_values',
  COMMENTS = 'comments',
  COPY_VALUE_LINK = 'copy_value_link',
  DELETE_ENTRIES = 'delete_entries',
  DELETE_FIELDS = 'delete_fields'
}

/**
 * The builder / config shape for a Context Menu Item.
 */
export type MenuItemBuilder = (context: CellContextMenuContext) => {
  isEnabled: () => boolean;
  menuItem: MenuItem;
};
